import {getAPIGatewayDataFromParent, getAPIGatewayRequest} from "../../handler/ParentDataHandler";
import {APIEndpoint} from "../../common/constants";

/**
 * This method will return remittance Details for Excel
 * @param params
 * @returns {Promise<*>}
 */
export async function getRemittanceExcelDetails(params) {
    const {remittanceId} = params;
    const requestArgs = { remittanceId };
    const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.GET_REMITTANCE_DETAILS_FOR_EXCEL, requestArgs, "POST");
    try {
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/component/remittance/network/RemittanceExcelDownloadAPI.js